import { render } from "./piechart.vue?vue&type=template&id=18b78cfc&scoped=true"
import script from "./piechart.vue?vue&type=script&lang=js"
export * from "./piechart.vue?vue&type=script&lang=js"

import "./piechart.vue?vue&type=style&index=0&id=18b78cfc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.2.13_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b78cfc"]])

export default __exports__